module.exports = __webpack_public_path__ + "img/phone.b522cc6c.svg";